module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_4_2-089124bd8393327aea2109ed0017a207.png";